const Stay = {
    roomName: '',
    stays_preference: '',
    is_booking: false,
    roomType: '',
    amount_reduce: 0,
    roomPrice: 0,
    customerName: '',
    customerPhone: '',
    stayNumber: '',
    stayType: '',
    stayTotalAmount: 0,
    stayAmountRemain: 0,
    staySold: '',
};
export default Stay;